export class AppConfig {
  public static siteName = 'Play Place';
  public static secretPassword = 'itchy';

  public static token = {
    id: 'ppt',
    symbol: 'PPT',
    enabled: true
  }

  public static coin = {
    id: 'coin',
    enabled: true
  }

  public static menu = [
    {
      text: 'Home',
      icon: 'home',
      to: '/',
      loggedIn: false
    },
    {
      text: 'Games',
      icon: 'games',
      to: '/games',
      loggedIn: false
    },
    {
      text: 'Shop',
      icon: 'shop',
      to: '/shop',
      loggedIn: true
    },
    {
      text: 'Inventory',
      icon: 'inventory',
      to: '/inventory',
      loggedIn: true
    },
    {
      text: 'Crafting',
      icon: 'crafting',
      to: '/crafting',
      loggedIn: true
    },
    {
      text: 'Messages',
      icon: 'messages',
      to: '/messages',
      loggedIn: true
    },
    {
      text: 'Friends',
      icon: 'friends',
      to: '/friends',
      loggedIn: true
    },
  ];
}